
document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelector('.tag-tabs-container');
  if (!tabs) return;

  function getTriggerPoint() {
    // change breakpoint if needed (768 = tablet/mobile)
    if (window.matchMedia('(max-width: 767px)').matches) {
      return 300; // mobile trigger
    } else {
      return 1000; // desktop trigger
    }
  }

  window.addEventListener('scroll', () => {
    const triggerPoint = getTriggerPoint();

    if (window.scrollY > triggerPoint) {
      tabs.classList.add('is-fixed');
    } else {
      tabs.classList.remove('is-fixed');
    }
  });
});